import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

// Simple cache of system users for the Actions responsible dropdown.
let _cache = null;
let _promise = null;

async function loadUsers() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = api.get("/users/directory")
    .then((r) => { _cache = r.data || []; _promise = null; return _cache; })
    .catch(() => { _promise = null; return []; });
  return _promise;
}

/**
 * Dropdown of system users (from /api/users/directory). Used in HSE Actions
 * so responsibles are always accountable users of the system — not free text.
 */
export default function UserSelect({ value = "", onChange, placeholder = "Buscar responsable…", testid, disabled }) {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState(value);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setQ(value); }, [value]);
  useEffect(() => { loadUsers().then(setUsers); }, []);
  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const matches = q
    ? users.filter((u) => {
        const n = q.toLowerCase();
        return u.name.toLowerCase().includes(n) || (u.email || "").toLowerCase().includes(n);
      }).slice(0, 8)
    : users.slice(0, 8);

  return (
    <div ref={boxRef} className="relative">
      <Input
        data-testid={testid}
        value={q}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => { setQ(e.target.value); onChange?.(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        autoComplete="off"
      />
      {open && matches.length > 0 && (
        <div
          data-testid={testid ? `${testid}-dropdown` : "user-select-dropdown"}
          className="absolute z-30 mt-1 w-full max-h-60 overflow-y-auto bg-white border border-slate-200 rounded-md shadow-lg"
        >
          {matches.map((u) => (
            <button
              key={u.id}
              type="button"
              data-testid={testid ? `${testid}-opt-${u.id}` : `user-opt-${u.id}`}
              onClick={() => { onChange?.(u.name); setQ(u.name); setOpen(false); }}
              className="w-full text-left px-3 py-1.5 hover:bg-slate-100 text-sm border-b last:border-b-0 border-slate-100"
            >
              <span className="font-semibold text-slate-900">{u.name}</span>
              <span className="text-slate-400 ml-2 text-xs">{u.email}</span>
              <span className="text-[10px] uppercase tracking-wider text-blue-800 ml-2">{u.role}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
